import React from 'react';

export const PolicyPrivacy: React.FC = () => {
  const PrivacyPolicyUrl = "https://docs.google.com/document/d/1iwYe6Gy_5krChvqqrYTqxjTtQrxHAOD6amloB6jvxTQ/preview?usp=sharing";

  return (
    <iframe
      src={PrivacyPolicyUrl}
      style={{ width: '100%', height: '90vh' }}
      title="Privacy Policy"
    />
  );
}
